export default __webpack_public_path__ + "24e13d646be98f73047d39ef589032a4.png";